import { RouteConfigComponentProps, renderRoutes } from 'react-router-config';

const Order = ({ route }: RouteConfigComponentProps) => {
  return <div>{renderRoutes(route?.routes)}</div>;
};

export default Order;